import { authMode, getProfile } from "./http";
import { hasPermissions } from "./permissions";

export const routePermissions = {
  Overall: ["VIEW_REPORTS"],
  RoundInfo: ["VIEW_ROUNDS"],
  Profile: ["MANAGE_TASKS", "VIEW_TASKS", "MANAGE_EMAILS"],
  Members: ["VIEW_USERS"],
  AddMember: ["MANAGE_USERS"],
  EditMember: ["MANAGE_USERS"],
  EditRound: ["MANAGE_ROUNDS"],
  CreateRound: ["MANAGE_ROUNDS"],
  AddMemberRound: ["MANAGE_MEMBERS"],
  CreateMemberRound: ["MANAGE_MEMBERS"],
  Contribution: ["VIEW_CONTRIBUTIONS"],
  Capital: ["VIEW_CONTRIBUTIONS"],
  Distribution: ["VIEW_DISTRIBUTIONS"],
  RecordPayment: ["VIEW_PAYMENTS"],
  RecordExpenses: ["MANAGE_SPENDING"],
  PaymentApproval: ["APPROVE_PAYMENTS"],
  Spendings: ["VIEW_SPENDING"],
  CreatePayment: ["MANAGE_PAYMENTS"],
  UploadPayments: ["MANAGE_PAYMENTS"],
  Convert: ["MANAGE_PAYMENTS"],
  Allloans: ["VIEW_LOANS", "MANAGE_LOANS"],
  LoanRequest: ["MANAGE_LOANS"],
  LoanAproval: ["APPROVE_LOANS"],
  LoanCheck: ["APPROVE_LOANS"],
  LoanEdit: ["MANAGE_LOANS"],
  LoanDetails: ["VIEW_LOANS", "MANAGE_LOANS"],
  IncomeReport: ["VIEW_REPORTS"],
  ExpenseReport: ["VIEW_REPORTS"],
  Cashbook: ["VIEW_REPORTS"],
  otherreports: ["VIEW_REPORTS"],
  Financialstatements: ["VIEW_REPORTS"],
  file: ["MANAGE_FILES"],
  Commissions: ["VIEW_CONTRIBUTIONS"],
  Penalties: ["VIEW_CONTRIBUTIONS"],
  Usergroups: ["MANAGE_USERGROUPS", "MANAGE_PERMISSIONS"],
  Adminsettings: ["VIEW_SETTINGS"],
  Myapproval: ["VIEW_REQUESTS", "APPROVE_REQUESTS"],
  Memberdetails: ["VIEW_MEMBERS"],
  Roundschedules: ["VIEW_DISTRIBUTIONS"],
  Assets: ["VIEW_ASSETS"],
  AddAsset: ["MANAGE_ASSETS"],
  EditAsset: ["MANAGE_ASSETS"],
};

export function canAccessRoute(path) {
  if (authMode() === "legacy") return true;
  if (!getProfile()) return false;
  const page = routePage(path);
  if (page === "MyMembership") return true;
  const permissions = routePermissions[page];
  return Boolean(permissions && hasPermissions(...permissions));
}

// react-router matches paths case-insensitively, so resolve the page name the same way before looking it up.
export function routePage(path) {
  const segment = path.split("/")[2] || "";
  const lower = segment.toLowerCase();
  if (lower === "mymembership") return "MyMembership";
  return Object.keys(routePermissions).find((page) => page.toLowerCase() === lower) || segment;
}

export function defaultMainPath() {
  return authMode() === "legacy" ? "/Main/Overall" : "/Main/MyMembership";
}